import React from 'react'
import { action, observable } from 'mobx'
import { getMerchantInfo, isSanDaTeam, isStoreAccount } from '@util'
import CommonStore from './CommonStore'
import Api from '@api/shou_xie/setMeal'
import CommonApi from '@api/common'
import API from '@api/bi_nuo'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { message, Modal } from 'hljd'

class Store extends CommonStore {
  $listApi = Api.listApi
  $pageSize = 30
  sub_merchant_id = '' // 司仪团队成员使用
  merchantInfo = getMerchantInfo() || {}
  @observable hadUpdateData
  $getParams = () => {
    const { key, coverPathFilter, memberFilter } = this
    const { order } = this.$sorter || {}
    const params = {
      commodity_type: 0,
      cover: coverPathFilter,
      emcee_member_id: memberFilter,
      is_sold_out: key == 4 ? 1 : 0,
      property_id: isStoreAccount() ? this.currentProperty : null,
      sub_merchant_id: this.sub_merchant_id,
      set_meal_sort: order
        ? order === 'ascend'
          ? 'sort_uv_asc'
          : 'sort_uv_desc'
        : ''
    }
    // key => 1: 已上架，2：审核中，3：审核未通过，4：已下架
    // status => 0:审核中 3:未通过审核，1:上下架，is_sold_out和status互斥，只能传1个
    if (key == 1 || key == 3) {
      params.status = key
    } else if (key == 2) {
      params.status = 0
    } else if (key == 4) {
      params.status = 1
    }
    this.hadUpdateData = false
    this.$loading = false
    return {
      with_pending: 1,
      ...this.$params,
      ...params
    }
  }

  @observable imgTagShow = false
  $extraOp = data => {
    let list = data.list
    for (let i in list) {
      if (+list[i].relate_examples_count > 0) {
        this.imgTagShow = true
      }
    }
  }

  @action
  $afterGet = (data, page) => {
    this.hadUpdateData = true
    const { list, total_count } = data
    this.$list = list || []
    this.$pagination.total = +total_count
    this.$pagination.current = page
    this.$selectedRowKeys = []
    this.$loading = false
    this.$extraOp && this.$extraOp(data, page)
  }

  @observable key = '1' // 已上架
  @action
  changeTab = e => {
    this.key = e.target.value
    // this.$getList(1)
  }

  @observable currentProperty = '1'

  @observable propertyList = []
  getPropertyList = async () => {
    const {
      data: { list }
    } = await Api.mealProperties({ commodity_type: 0 })

    this.propertyList = list || []
  }

  changeProperty = id => {
    this.currentProperty = id
    this.$getList(1)
  }

  @observable ratingTotal = 0
  @action
  getRatingList = async () => {
    //需要优化的数量
    let params = {
      page: 1,
      per_page: 1,
      commodity_type: 0,
      rating: 1
    }
    let {
      data: { total_count },
      success
    } = await Api.listApi(params)
    if (success) {
      this.ratingTotal = total_count
    }
  }
  @observable showCaseCount = 0
  @action
  getshowCaseCount = async () => {
    let {
      data: { total_count },
      success
    } = await CommonApi.showCaseListApi()
    if (success) {
      this.showCaseCount = total_count
    }
  }

  showModalMove = (id, flag, is_in_brand) => () => {
    if (is_in_brand) {
      return Modal.info({
        title: '套餐在品牌页中不可移除'
      })
    }
    Modal.confirm({
      title: '你是否确认移除该套餐，该操作不可恢复',
      onOk: () => {
        this.deleteSetMealFn(id, flag)
      }
    })
  }

  @observable
  modalIf = {
    type: '',
    isShow: false,
    btn1: '',
    btn2: '',
    content: ''
  }

  @action
  onCancel = () => {
    this.modalIf.isShow = false
  }

  // 191010 临时放四大团队成员数据
  @observable siDaMemberList = []

  /* ————————————————list-设置竖图————————————————*/
  @observable verticalImgVisible = false
  @observable vertical_image = ''

  // 弹窗-打开
  @action
  showVerticalImgModal = ({ id, cover_path }) => {
    this.vertical_image = cover_path
    this.current_id = id
    this.verticalImgVisible = true
  }

  // 弹窗-取消
  @action
  closeVerticalImgModal = () => {
    this.vertical_image = ''
    this.current_id = ''
    this.verticalImgVisible = false
  }

  // 弹窗-保存
  @action
  saveVerticalImgModal = () => {
    // 清空链接，关闭弹窗
    this.closeVerticalImgModal()
  }

  // 图片裁剪
  @action
  verticalImgModalonCliped = url => {
    this.vertical_image = url
    this.sendVerticalImg(url)
    this.closeVerticalImgModal()
  }

  // 图片删除
  @action
  verticalImgModalonDelete = () => {
    this.vertical_image = ''
  }

  @action
  sendVerticalImg = async vertical_image => {
    console.warn(vertical_image)
    const { success } = await API.editVerticalImage({
      id: this.current_id,
      vertical_image
    })
    if (success) {
      this.$getList()
    }
  }

  // 是否设置了套餐竖图
  @observable hasSetVerticalImg = true
  @action
  hasSetMealVerticalImg = async () => {
    const { success, data } = await API.isEditVerticalImage({ type: 0 })
    if (success) {
      // 检测是否需要竖图弹窗接口，需要取返
      this.hasSetVerticalImg = !data
    }
  }

  // 页面顶部：审核概览+是否设置竖图
  @observable pageHeaderInfo = {}
  @action
  getPageHeaderInfo = async () => {
    const { success, data } = await API.getPageHeaderInfo({ type: 1 }) // 1 套餐  2 案例  3 单品
    if (success) {
      this.pageHeaderInfo = data
    }
  }

  // 点击草稿箱
  @observable draftBoxCount = 0
  @action
  getDraftBoxCount = async () => {
    const { success, data } = await API.getDraftBoxCount()
    if (success) {
      this.draftBoxCount = data
    }
  }

  // 初始化页面
  initialPage = () => {
    // 页面顶部：审核概览+是否设置竖图
    this.getPageHeaderInfo()

    // 获取草稿箱数量(三大团队不显示，故不请求接口)， 司仪团队可以获取草稿
    !isSanDaTeam() && this.getDraftBoxCount()
  }

  @observable selectedRowKeys = [] // 批量操作选择的项
  /** 选择套餐 */
  onSelectChange = selectedRowKeys => {
    this.selectedRowKeys = selectedRowKeys
  }

  /**
   * 批量上架/下架
   */
  multiSetPackage = () => {
    if (!this.selectedRowKeys.length) {
      message.warn('请先选择套餐')
      return
    }
    const operateType = this.key == 1 ? '下架' : '上架'
    Modal.confirm({
      title: `确定要批量${operateType}吗`,
      icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
      onOk: async () => {
        const { RetCode, msg } = await API.multiSetPackageOrCaseApi({
          ids: this.selectedRowKeys,
          sold_out: this.key == 1 ? '1' : '0',
          commodity_type: '0' // 0套餐  1案例
        })

        if (RetCode === 0) {
          message.success('操作成功')
          this.onMultiOperateDone()
        } else if (RetCode === 8092) {
          Modal.warning({
            title: `操作成功`,
            content: `部分套餐因被用于广告创意或其他原因，导致无法${operateType}。请单独修改后重新操作。`,
            icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
          })
          this.onMultiOperateDone()
        } else {
          message.error(msg)
        }
      }
    })
  }

  /**
   * 批量删除
   */
  multiDeletePackage = () => {
    if (!this.selectedRowKeys.length) {
      message.warn('请先选择套餐')
      return
    }
    Modal.confirm({
      title: `确定要批量删除吗`,
      content: (
        <div>
          <span style={{ color: '#F04134' }}>删除后内容不可恢复</span>，确定删除吗？
        </div>
      ),
      icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />,
      onOk: async () => {
        const { RetCode, msg } = await API.multiDeletePackageOrCaseApi({
          ids: this.selectedRowKeys,
          commodity_type: '0' // 0套餐  1案例
        })

        if (RetCode === 0) {
          message.success('操作成功')
          this.onMultiOperateDone()
        } else if (RetCode === 8092) {
          Modal.warning({
            title: `操作成功`,
            content: `部分套餐因被用于广告创意或其他原因，导致无法删除。请单独修改后重新操作。`,
            icon: <ExclamationCircleFilled style={{ color: '#ffbf00' }} />
          })
          this.onMultiOperateDone()
        } else {
          message.error(msg)
        }
      }
    })
  }

  /** 批量操作结束，清空状态 */
  onMultiOperateDone = () => {
    this.selectedRowKeys = []
    this.$getList(1)
  }

  /* 封面图筛选下拉框 */
  @observable coverPathFilter = '0'
  @action
  onCoverPathChange = v => {
    this.coverPathFilter = v
    this.$getList(1)
  }

  /* 成员筛选 */
  @observable memberFilter = ''
  @action
  onMemberSelect = v => {
    this.memberFilter = v
    this.$getList(1)
  }
}
export default new Store()
